import type { Character } from "@cloudnest/horror-race-engine";
import { HorrorCharacterChip } from "./HorrorCharacterChip";

interface DrawnCoinsPreviewProps {
  readonly coins: readonly Character[];
  readonly testId?: string;
}

/**
 * Read-only view of the active player's drawn coins, shown to WAITING players
 * (wireframe §02.3 ⓑ). Drawn coins are public to all sessions in the
 * server-authoritative flow, but waiting players previously saw only the
 * "…님이 배치 중…" status with no indication of WHICH tokens were drawn. This
 * renders the same labeled chips as the placement hand — no zone controls.
 */
export function DrawnCoinsPreview({
  coins,
  testId = "horror-drawn-coins-preview",
}: DrawnCoinsPreviewProps) {
  if (coins.length === 0) return null;

  return (
    // T22 — flattened: no nested card chrome or "뽑은 코인" header. The bottom bar
    // supplies the surface and the action-status line ("…님이 배치 중…") is the
    // single description; this just shows which coins were drawn.
    <div data-testid={testId} className="flex items-start justify-center gap-5">
      {coins.map((coin, index) => (
        <HorrorCharacterChip
          key={index}
          character={coin}
          iconSize={28}
          labelSize={11}
        />
      ))}
    </div>
  );
}
